import React, { useEffect, useRef, useState } from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { useDataSourceProps } from '../hooks/form/useDataSourceProps';
import { useFormContext } from '../FormContext';
export const FormDateField = ({ element, edit, disabled }) => {
    var _a;
    const { formState, formValues, setFormValue } = useFormContext();
    const key = element.dataSource || element.key;
    const [touched, setTouched] = useState(false);
    let [value, setValue] = useState(formValues[key] || null);
    const previousValueRef = useRef(value);
    const dataSourceProps = useDataSourceProps(element, value);
    // refresh value if formValues change outside of the component
    useEffect(() => {
        if (formValues[key] && previousValueRef.current !== formValues[key]) {
            setValue(formValues[key]);
            previousValueRef.current = formValues[key];
        }
    }, [formValues, key]);
    const { minDate = undefined, maxDate = undefined } = element.config || {};
    const dateType = (_a = element.config) === null || _a === void 0 ? void 0 : _a.dateType;
    const datePickerProps = {
        minDate,
        maxDate
    };
    switch (dateType) {
        case 'birth':
            datePickerProps.disableFuture = true;
            datePickerProps.openTo = 'year';
            datePickerProps.views = ['year', 'month', 'date'];
            break;
        case 'future':
            datePickerProps.disablePast = true;
            break;
        default:
            break;
    }
    // fix date input format
    if (value &&
        typeof value === 'string' &&
        value.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // fix date only fields (otherwise date offset by 1)
        value = `${value}T00:00:00`;
    }
    return (React.createElement(KeyboardDatePicker, Object.assign({ fullWidth: true, clearable: true, variant: 'dialog', disabled: edit || disabled, inputVariant: 'outlined', format: 'MM/dd/yyyy', value: value, error: dataSourceProps.error, helperText: dataSourceProps.helperText, onChange: date => {
            setValue(date);
            setTouched(true);
        }, onAccept: date => {
            // save when selecting from popup dialog
            if (formValues[key] !== date) {
                setFormValue(key, date);
            }
        }, onBlur: event => {
            if (touched && formValues[key] !== value) {
                setFormValue(key, value);
            }
        } }, datePickerProps)));
};
export default FormDateField;
//# sourceMappingURL=FormDateField.js.map